import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { categories, categoryImages } from "@/mocks/categories";

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <div ref={ref} className="relative w-full max-w-md">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between rounded-lg border border-foreground-200 bg-background-50 px-4 py-3 text-left text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
      >
        <span className="whitespace-nowrap">{t("cat.dropdownLabel")}</span>
        <span className="w-5 h-5 flex items-center justify-center">
          <i className={`${open ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} text-lg text-foreground-600`}></i>
        </span>
      </button>

      {open && (
        <div className="absolute z-30 mt-2 max-h-96 w-full overflow-y-auto rounded-lg border border-foreground-200 bg-background-50 py-1">
          {categories.map((c) => (
            <a
              key={c.id}
              href={c.href}
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setOpen(false)}
              className="flex items-center gap-3 px-3 py-2 text-sm text-foreground-800 transition-colors hover:bg-background-100"
            >
              <span className="h-10 w-10 shrink-0 overflow-hidden rounded-md">
                <img
                  src={categoryImages[c.id]}
                  alt={t(`cat.${c.id}`)}
                  className="h-full w-full object-cover object-top"
                />
              </span>
              <span className="flex-1 whitespace-nowrap">{t(`cat.${c.id}`)}</span>
              <span className="w-4 h-4 shrink-0 flex items-center justify-center">
                <i className="ri-external-link-line text-foreground-400"></i>
              </span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}